export const CUSTOMER_SET = 'CUSTOMER_SET';
export const CUSTOMER_LOADING = 'CUSTOMER_LOADING';
export const CUSTOMER_ERROR = 'CUSTOMER_ERROR';

export const CUSTOMER_SET_AVAILABLE_ADDRESSES = 'CUSTOMER_SET_AVAILABLE_ADDRESSES';
export const CUSTOMER_CLEAR_AVAILABLE_ADDRESSES = 'CUSTOMER_CLEAR_AVAILABLE_ADDRESSES';
